import React, { useState } from 'react';
import Styles from './MeuFinanciamentoBanner.css';
import Container from '@/components/atoms/Container';
import WhiteButton from '@/components/atoms/WhiteButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
function MeuFinanciamentoBanner() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="meu-financiamento-banner" className="stacked-banner">
        <div className="bg-image-wrapper">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 992 && (
                <picture>
                  <source type="image/webp" srcSet="assets/meu-financiamento/banner-hero.webp" />
                  <source type="image/png" srcSet="assets/meu-financiamento/banner-hero.png" />
                  <img
                    src="assets/meu-financiamento/banner-hero.png"
                    alt="Mulher de cabelos longos e blusa vermelha xadrez observando seu financiamento no portal do cliente da Santander Financiamentos"
                  />
                </picture>
              )}
              {width > 992 && (
                <picture>
                  <source type="image/webp" srcSet="assets/meu-financiamento/banner-hero.webp" />
                  <source type="image/png" srcSet="assets/meu-financiamento/banner-hero.png" />
                  <img
                    src="assets/meu-financiamento/banner-hero.png"
                    alt="Mulher de cabelos longos e blusa vermelha xadrez observando seu financiamento no portal do cliente da Santander Financiamentos"
                  />
                </picture>
              )}
            </>
          )}
        </div>
        {/* <div className="fade-banner" /> */}
        <div className="fade-banner-gradiente" />
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <h1 className="main-text">Consultar financiamento</h1>
              <p className="alt-text">
                Se você possui um financiamento com o Santander, conte com todas as facilidades que
                preparamos para você.
              </p>
              <WhiteButton
                href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento:banner&int_campaign=consultar"
                rel="noopener"
                target="_blank"
                className="btn-simulate"
              >
                Consultar
              </WhiteButton>
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default MeuFinanciamentoBanner;
